import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

let counter=0;
const PackSearch = ({onChange}) => { 
    const [value, setValue] = useState('');

    const _onChange = useCallback((e) => {
        let _text = e.target.value;
        setValue(_text);
        let _counter = (++counter);
        setTimeout(() => {
            if (_counter !== counter) { return; }
            onChange(_text);
        }, 250);
    }, [setValue, onChange]);

    const clear = useCallback(() => {
        setValue('');
        onChange('');
    }, [onChange, setValue]);

    return (
        <div className="pack-search-container">
          <input placeholder="Type to search" onChange={_onChange} type="text" className="pack-search" value={value}/>
          <div onClick={clear} className="clear-btn">x</div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PackSearch);
